import type { Route } from '../../routing/routes';
import { renderDiscoveryGuide } from './render';

export function DiscoveryGuide({ route, basePath }: { route: Route; basePath: string }) {
  const html = renderDiscoveryGuide(route, basePath);
  // Escaped, source-owned content; never accept user input or backend HTML here.
  return html ? <div className="discovery-guide-wrap" dangerouslySetInnerHTML={{ __html: html }} /> : null;
}
